// Expose React globals for PHP templates
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './index.js';

window.React = React;
window.ReactDOM = { createRoot };
window.Components = { App };
